import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function swms() {
    return request({
        url: V1_API_URL_PREFIX + "/swms",
        method: 'GET'
    });
}

export function swmsRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/swms/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateSwms(record) {
    return request({
        url: V1_API_URL_PREFIX + "/swms/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function addSwmsRevision(record) {
    return request({
        url: V1_API_URL_PREFIX + "/swms/add/revision",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteSwms(swms) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/swms/delete",
        method: 'DELETE',
        body: JSON.stringify(swms)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}